import { render, staticRenderFns } from "./AlertsItemDetails.vue?vue&type=template&id=30ba9615&scoped=true"
import script from "./AlertsItemDetails.vue?vue&type=script&lang=js"
export * from "./AlertsItemDetails.vue?vue&type=script&lang=js"
import style0 from "./AlertsItemDetails.vue?vue&type=style&index=0&id=30ba9615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ba9615",
  null
  
)

export default component.exports